<template>
	<div class="apply">
		<div class="form-t">
			<p class="title">{{ title }}</p>{{ titleEngLish }}
		</div>
		<div class="apply-ipt">
			<img class="ipt-img" src="../../static/home/user_name.png" alt="" />
			<el-input class="ipt" v-model="userName" placeholder="请输入您的姓名" clearable></el-input>
		</div>
		<div class="apply-ipt">
			<img class="ipt-img" src="../../static/home/phone_number.png" alt="" />
			<el-input class="ipt" v-model="userPhone" placeholder="请输入您的手机号" clearable></el-input>
		</div>
		<div class="verification-code">
			<div class="apply-ipt code-ipt">
				<el-input class="ipt" v-model="code" placeholder="请输入验证码" clearable></el-input>
			</div>
			<img @click="getCode" class="img" :src="img" alt="" />
		</div>
		<div class="apply-btn" @click="submit">立即申请</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: '借款申请'
			},
			titleEngLish: {
				type: String,
				default: 'BORROWING APPLICATIO'
			},
			clueType: {
				type: Number,
				default: ''
			},
		},
		data () {
			return {
				userName: '',
				userPhone: '',
				code: '',
				img: '',
				uuid: '',
			}
		},
		created() {
			this.getCode()
		},
		methods: {
			async getCode() {
				let res = await this.util.request({
					url: `/sy/getLfWebsite/formCode`,
					method: 'GET',
					data: {},
				});
				if (res.status === 200) {
					this.img = res.data.img;
					this.uuid = res.data.uuid;
				} 
			},
			submit() {
				if (this.userName == '') {
					this.$message.error('请输入姓名');
					return false
				}
				if (this.userPhone == '') {
					this.$message.error('请输入手机号');
					return false
				}
				if (this.code == '') {
					this.$message.error('请输入验证码');
					return false
				}
				
				let res = this.util.request({
					url: `/sy/getLfWebsite/submitFrom`,
					method: 'POST',
					data: {
						isCode: 1,
						userName: this.userName,
						userPhone: this.userPhone,
						clueType: this.clueType,
						uuid: this.uuid,
						code: this.code,
					},
				}).then(res => {
					if (res.status === 200) {
						this.$emit('dialogFun', true)
					}
				}).catch(error => {
					this.$message.error(error);
				});
			},
		}
	}
</script>

<style>
	.apply {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translateY(-50%);
		margin-left: 180px;
		z-index: 99;
		background: rgba(0, 0, 0, .3);
		border-radius: 8px;
		padding: 40px 43px 60px;
	}
	
	.form-t {
		font-size: 14px;
		color: #CF2427;
		margin-bottom: 20px;
	}
	
	.form-t .title {
		font-weight: 600;
		font-size: 26px;
		color: #FFFFFF;
	}
	
	.apply-ipt {
		padding: 0 11px;
		height: 44px;
		line-height: 44px;
		background: #FFFFFF;
		border-radius: 22px;
		margin-bottom: 15px;
		display: flex;
		align-items: center;
	}
	
	.ipt-img {
		width: 22px;
		height: 22px;
		margin-right: 10px;
	}
	
	.ipt::placeholder {
		color: #999;
	}
	
	.ipt .el-input__inner {
		border: none;
		font-size: 13px;
		color: #333;
		padding: 0;
	}
	
	.apply-btn {
		width: 234px;
		height: 44px;
		line-height: 44px;
		background: #CF2427;
		border-radius: 22px;
		font-weight: 600;
		font-size: 15px;
		color: #FFFFFF;
		text-align: center;
	}
	
	.verification-code {
		display: flex;
	}
	.code-ipt {
		width: 105px;
		margin-right: 10px;
	}
	.verification-code .img {
		cursor: pointer;
		width: 94px;
		height: 44px;
		background: #FFFFFF;
	}
</style>


// WEBPACK FOOTER //
// src/components/ApplyForm.vue